export const gettext = (string) => string;